import { Applicant, ApplicantAddressType, ApplicationProps } from '../redux-store/types/api-types';
import {
  applicantStatusMasters,
  ApplicationSourceMaster,
  APPLICATION_LISTING_STATUS,
  APPLICATION_TYPE,
  CurrencyMaster,
  SALT,
  SALT2,
  USER_ROLES,
  YesNoMaster,
  timeZoneFromServer,
  INVESTOR_IMAGE_UPLOAD_FORMATS,
  IMAGE_UPLOAD_FORMATS,
  ApplicationStatusBasedOnRole,
  IndividualApplicationStatusBasedOnRole,
  APPLICATION_STATUS,
  defaultCurrency,
  FINAL_DOC_UPLOAD_FORMATS,
  ENABLE_RTA_APPROVER,
  AccreditedInvestorMandatoryDate,
} from './constant';
import { ToWords } from 'to-words';
import { numberRegex } from './regex';
import _ from 'lodash';
import AdapterMoment from '@mui/lab/AdapterMoment';
import momentTimezone from 'moment-timezone';
import { updatedBank } from '../components/investors/bankDetails';
import { updatedInvestmentProfile } from '../components/ApplicationDetails/investmentProfile';
import { mdmsCountriesList } from '../redux-store/types/mdms';
import en from '../lang/en-us';

export const maskMobileNumber = (mobileNumber: string): string => {
  if (!mobileNumber) {
    return '';
  }
  return (
    mobileNumber.slice(0, 2) +
    mobileNumber.slice(2, mobileNumber.length - 2).replace(/\d/g, '*') +
    mobileNumber.slice(mobileNumber.length - 2)
  );
};

export const getApplicantName = (index: number, isNomineeOrBank?: boolean): string => {
  if (index === 1) {
    return isNomineeOrBank ? 'First' : 'First/Sole';
  } else if (index === 2) {
    return 'Second';
  } else {
    return 'Third';
  }
};

export const minDateForContributor = (): Date => {
  const date = new Date();
  date.setFullYear(date.getFullYear() - 18);
  return date;
};

export const getFirstHolderName = (applicants: Partial<Applicant>[]): string => {
  return (
    applicants.find((applicant) => ['firstapplicant', '1'].includes(applicant.applicant_type || ''))
      ?.name || 'N/A'
  );
};

export const changeGoalVal = (
  ans: string,
  investmentProfileData: updatedInvestmentProfile[],
  question: string
) => {
  const ansArray = ans.split('*').map((val) => {
    const index = val.indexOf('_');
    const result = val.substring(0, index);
    return result;
  });
  const valueArray = investmentProfileData.find(
    (profile) => profile?.question === question
  )?.values;
  const labelsArray = ansArray.map((key) => {
    const item = valueArray?.find((val) => val.key === key);
    return item ? `${item.label}` : key;
  });
  return labelsArray;
};

export const getApplicantType = (applicantType: string | undefined): string => {
  if (applicantType) {
    if (['firstapplicant', '1'].includes(applicantType)) {
      return '1';
    } else if (['secondapplicant', '2'].includes(applicantType)) {
      return '2';
    } else {
      return '3';
    }
  }
  return '';
};

export const formatToIndianCurrency = (value: number | null): string => {
  const options = { style: 'currency', currency: 'INR' };
  if (value) {
    return new Intl.NumberFormat('en-IN', options).format(value);
  }
  return '';
};

export function toExactSubstr(str: string): string {
  const a = str.split('.');
  if (a.length == 2) {
    return a[0]?.concat('.', a[1].substr(0, 2));
  }
  return str;
}

export const formatCurrency = (value?: number | null): string => {
  const formats = ['K', 'L', 'Cr'];
  let amount: any = Number(value);
  formats.some((key, i) => {
    const size = Math.pow(10, i === 0 ? 3 : 3 - 1);
    if (size <= amount) {
      amount = toExactSubstr(`${amount / size}`);
      if (amount >= 100 && i < formats.length - 1) {
        i++;
      } else {
        // amount = (amount * decPlaces) / decPlaces;
        amount += ' ' + formats[i];
        return true;
      }
    } else {
      return true;
    }
  });
  return amount;
};

export const EIGHTEEN_YEARS_IN_MILLISECONDS = 18 * 31556926 * 1000; //  18 * no of seconds in a Year * 1000

export const isMinor = (dateOfBirth = ''): boolean => {
  return new Date().getTime() - new Date(dateOfBirth).getTime() < EIGHTEEN_YEARS_IN_MILLISECONDS;
};

// eslint-disable-next-line @typescript-eslint/no-var-requires
const countryCodes = require('country-codes-list');
export const getCountryCodes = (): { label: string; key: string; countryCode: string }[] => {
  const countryCodesObject: { [key: string]: string } = countryCodes.customList(
    'countryCode',
    '{countryNameEn}: +{countryCallingCode}'
  );

  const modifiedCodes = Object.keys(countryCodesObject).map((cc) => ({
    label: countryCodesObject[cc],
    key: countryCodesObject[cc].split(':')[1].trim(),
    countryCode: cc,
  }));
  return modifiedCodes;
};

export const getAddressFields = (addressType: string): ApplicantAddressType => {
  return {
    //if adding some additional fields in the addresse check these function also (permanentAddressSameAsCorresponding,updateAddressDataFunction )
    address1: '',
    address2: '',
    // address3: '',
    city: '',
    state: '',
    country: '',
    pincode: '',
    permanentAddressSameAsCorresponding: false,
    address_type: addressType,
    isActive: true,
    fetchedFromKRA: null,
  };
};

export const getAddressData = (
  addressType: string,
  addresses: Partial<ApplicantAddressType>[] | undefined
): Partial<ApplicantAddressType> => {
  return (
    addresses?.find((address) => address.address_type === addressType) ||
    getAddressFields(addressType)
  );
};

export function getRelation(relationValue?: string | null): boolean {
  return ['Mother', 'Father', 'Daughter', 'Son', 'Spouse', 'Brother', 'Sister', ''].includes(
    relationValue || ''
  );
}

export const saveForLater = (
  role: string,
  id?: string,
  applicant1ReferenceId?: string | null
): string => {
  return role === USER_ROLES.INVESTOR
    ? ''
    : // ? `/investment-details/${applicant1ReferenceId}/application-details`
    role === USER_ROLES.POAAPPROVER || role === USER_ROLES.AMCAPPROVER
    ? `/application-details/${id}`
    : '/applications';
};

export const maxAge = (dateOfBirth = ''): boolean => {
  const thisYear = new Date().getFullYear();
  return thisYear - new Date(dateOfBirth).getFullYear() > 125;
};

export function currencyConversion(
  num?: string | number | null,
  currencyType?: string | null
): string | null {
  if (!num) return '';
  const toWords = new ToWords({
    localeCode: Object.keys(CurrencyMaster).includes(currencyType?.toLowerCase() || '')
      ? CurrencyMaster[currencyType?.toLowerCase() || defaultCurrency]?.localeCode
      : CurrencyMaster[defaultCurrency]?.localeCode,
  });
  const words = toWords.convert(Number(num), { currency: true });
  return words;
}

export function checkIfApplicationIsNonIndividual({ applicationType }: ApplicationProps): boolean {
  return applicationType === APPLICATION_TYPE.NON_INDIVIDUAL;
}

// eslint-disable-next-line
export const preventSpecialCharacters = (e: any) => {
  if (
    !((e.ctrlKey || e.metaKey) && e.keyCode == 67) &&
    !((e.ctrlKey || e.metaKey) && e.keyCode == 86) &&
    !((e.ctrlKey || e.metaKey) && e.keyCode == 88) &&
    !((e.ctrlKey || e.metaKey) && e.keyCode == 90) &&
    !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Enter', 'Tab'].includes(e.key) &&
    !numberRegex.test(e.key)
  ) {
    e.preventDefault();
  }
};
export function allowOnlyNumbers(e: any): void {
  if (['-', '+', 'e', 'E'].includes(e.key)) {
    e.preventDefault();
  }
}
export const permanentAddressSameAsCorresponding = (
  updatedCorrespondingAddress: Partial<ApplicantAddressType>,
  addressType: string,
  addresses: Partial<ApplicantAddressType>[] | undefined
): Partial<ApplicantAddressType> => {
  // eslint-disable-next-line
  const { address1, address2, city, pincode, state, country, ...rest } =
    updatedCorrespondingAddress;
  return {
    ...getAddressData(addressType, addresses),
    address1: address1,
    address2: address2,
    city: city,
    pincode: pincode,
    state: state,
    country: country,
    address_type: addressType,
  };
};
export const _updatedAddresses = (
  updatedAddresses: {
    nationality?: string | null | undefined;
    status?: string | null | undefined;
    permanent?: Partial<ApplicantAddressType> | undefined;
    correspondence?: Partial<ApplicantAddressType> | undefined;
    overseas?: Partial<ApplicantAddressType> | undefined;
    [key: string]: string | Partial<ApplicantAddressType> | null | undefined;
  },
  applicant: Partial<Applicant>
): Partial<ApplicantAddressType>[] => {
  const { nationality, status, ...addressProps } = updatedAddresses;
  return Object.keys(addressProps)
    .map((addressType) => {
      // if (applicant.nationality?.toLowerCase() === 'indian' && addressType === 'overseas') {
      //   return {};
      // }
      if (
        addressType === 'permanent' &&
        addressProps['overseas']?.permanentAddressSameAsCorresponding
      ) {
        return permanentAddressSameAsCorresponding(
          addressProps['overseas'],
          addressType,
          applicant.addresses
        );
      }
      if (
        addressType === 'permanent' &&
        addressProps['correspondence']?.permanentAddressSameAsCorresponding &&
        !addressProps['overseas']
      ) {
        return permanentAddressSameAsCorresponding(
          addressProps['correspondence'],
          addressType,
          applicant.addresses
        );
      }
      if (
        Object.keys(addressProps).length === 1 &&
        addressProps['overseas']?.permanentAddressSameAsCorresponding
      ) {
        return [
          {
            ...permanentAddressSameAsCorresponding(
              addressProps['overseas'],
              'permanent',
              applicant.addresses
            ),
          },
          {
            ...getAddressData(addressType, applicant.addresses),
            ...(addressProps[addressType] as unknown as Partial<ApplicantAddressType>),
            address_type: addressType,
          },
        ];
      }
      if (
        Object.keys(addressProps).length === 1 &&
        addressProps['correspondence']?.permanentAddressSameAsCorresponding
      ) {
        return [
          {
            ...permanentAddressSameAsCorresponding(
              addressProps['correspondence'],
              'permanent',
              applicant.addresses
            ),
          },
          {
            ...getAddressData(addressType, applicant.addresses),
            ...(addressProps[addressType] as unknown as Partial<ApplicantAddressType>),
            address_type: addressType,
          },
        ];
      }
      return {
        ...getAddressData(addressType, applicant.addresses),
        ...(addressProps[addressType] as unknown as Partial<ApplicantAddressType>),
        address_type: addressType,
      };
    })
    .flat()
    .filter((address) => Object.keys(address).length);
};
export const applyRoleBasedStatus = (role: any): boolean => {
  return [
    USER_ROLES.RM,
    USER_ROLES.SUBDISTRIBUTOR,
    USER_ROLES.DISTRIBUTOR,
    USER_ROLES.AMCAPPROVER,
  ].includes(role);
};

export const checkKraBasedOnStatus = (status: any): boolean => {
  return ![
    APPLICATION_LISTING_STATUS.invitationexpired,
    APPLICATION_LISTING_STATUS.signed,
    APPLICATION_LISTING_STATUS.completed,
    APPLICATION_LISTING_STATUS.rejected,
  ].includes(APPLICATION_LISTING_STATUS[status]);
};

export const applicationComparison = (
  existingApplication: Partial<ApplicationProps> | null,
  updatedApplication: Partial<ApplicationProps>
): boolean => {
  return _.isEqual(existingApplication, updatedApplication);
};

export const sendApplication_Nri = (application?: ApplicationProps | null): boolean | undefined => {
  return application?.applicants.map((applicant) => applicant.status).includes('NRI');
};

export const checkForCorrespondenceAddress = (
  nationality: string | null | undefined,
  status: string | null | undefined
): boolean => {
  return (
    nationality?.toLowerCase() === 'indian' &&
    applicantStatusMasters[status as string] === applicantStatusMasters.Individual
  );
};

export const setUpFeeCalculations = (
  commitmentAmount: number,
  setupFeePercentage: number
): { feeAmount: number; feeGst: number; totalSetupFee: number } => {
  const setupFeeAmount = (Number(commitmentAmount) * Number(setupFeePercentage)) / 100;
  const GstForSetupFee = (setupFeeAmount * 18) / 100;
  return {
    feeAmount: Number(setupFeeAmount),
    feeGst: Number(GstForSetupFee),
    totalSetupFee: Number(setupFeeAmount + GstForSetupFee),
  };
};

export const checkAddressField = (data?: string) => {
  if (data) {
    if (data.includes(' ,')) {
      return data.split(' ,').join(',') + ' ';
    }
    return data.includes(',') ? data + ' ' : data + ', ';
  }
  return '';
};

export function updateAddressDataFunction(updatePayload: Partial<Applicant>[]) {
  return updatePayload
    ?.map((_applicant) => {
      const firstApplicantAddress = updatePayload?.find(
        (e) => e.applicant_type?.toString() === '1'
      )?.addresses;

      const firstApplicantPermanent = firstApplicantAddress?.find(
        (e) => e.address_type === 'permanent'
      );
      const firstApplicantorrespondence = firstApplicantAddress?.find(
        (e) => e.address_type === 'correspondence'
      );

      return {
        ..._applicant,
        addresses: _applicant.applicantAddressSameAsFirstApplicant
          ? _applicant.addresses?.map((address) => {
              return {
                ...address,
                address1:
                  address.address_type === 'permanent'
                    ? firstApplicantPermanent?.address1
                    : firstApplicantorrespondence?.address1,
                address2:
                  address.address_type === 'permanent'
                    ? firstApplicantPermanent?.address2
                    : firstApplicantorrespondence?.address2,
                city:
                  address.address_type === 'permanent'
                    ? firstApplicantPermanent?.city
                    : firstApplicantorrespondence?.city,
                pincode:
                  address.address_type === 'permanent'
                    ? firstApplicantPermanent?.pincode
                    : firstApplicantorrespondence?.pincode,
                state:
                  address.address_type === 'permanent'
                    ? firstApplicantPermanent?.state
                    : firstApplicantorrespondence?.state,
                country:
                  address.address_type === 'permanent'
                    ? firstApplicantPermanent?.country
                    : firstApplicantorrespondence?.country,
                address_type:
                  address.address_type === 'permanent'
                    ? firstApplicantPermanent?.address_type
                    : firstApplicantorrespondence?.address_type,
                permanentAddressSameAsCorresponding:
                  address.address_type === 'permanent'
                    ? firstApplicantPermanent?.permanentAddressSameAsCorresponding
                    : firstApplicantorrespondence?.permanentAddressSameAsCorresponding,
              };
            })
          : _applicant.addresses,
      };
    })
    .map((_applicant) => {
      return {
        ..._applicant,
        addresses: _applicant.addresses?.map((address) => {
          return {
            ...address,
            address1: removeSingleQuote(address.address1),
            address2: removeSingleQuote(address.address2),
            city: removeSingleQuote(address.city),
            state: removeSingleQuote(address.state),
          };
        }),
      };
    });
}

export const getBankAddress = (
  address1: string | undefined,
  address2: string | undefined,
  address3: string | undefined
): string => {
  return `${address2 ? checkAddressField(address1) || '' : address1 || '' || ''}${
    address3 ? checkAddressField(address2) || '' : address2 || ''
  }${address3 || ''}`;
};

export function folioValidationCheck(applicationSource: string): boolean {
  return ApplicationSourceMaster[applicationSource] === ApplicationSourceMaster.migration;
}

export const numToAlpMonth = (numMonth: any, month: any) => {
  numMonth?.map((monthNum: any) => {
    if (monthNum === 1) {
      month.push('Jan');
    } else if (monthNum === 2) {
      month.push('Feb');
    } else if (monthNum === 3) {
      month.push('Mar');
    } else if (monthNum === 4) {
      month.push('Apr');
    } else if (monthNum === 5) {
      month.push('May');
    } else if (monthNum === 6) {
      month.push('Jun');
    } else if (monthNum === 7) {
      month.push('Jul');
    } else if (monthNum === 8) {
      month.push('Aug');
    } else if (monthNum === 9) {
      month.push('Sep');
    } else if (monthNum === 10) {
      month.push('Oct');
    } else if (monthNum === 11) {
      month.push('Nov');
    } else if (monthNum === 12) {
      month.push('Dec');
    }
  });
};

export const removeSingleQuote = (value: string | null | undefined): any => {
  if (value && value.includes("'")) return value.split("'").join('');
  else return value;
};

export function removeEqualOperator(value = ''): string {
  const lastTwoIndex = value.length - 2;
  let encodeString = value.slice(0, lastTwoIndex);
  const slicedStr = value.slice(lastTwoIndex, value.length);
  slicedStr.split('').forEach((char) => {
    if (char !== '=') {
      encodeString += char;
    }
  });
  return encodeString;
}

export const checkAnsPresentKYC = (ques: any) => {
  let show = false;
  ques.forEach((element: any) => {
    if (element.answer) {
      show = true;
    }
  });
  return show;
};

export function encodeBase64(value: string): string {
  const encodeValue = btoa(value);
  const encodeSubString = removeEqualOperator(encodeValue);
  const encodePayload = btoa(`${SALT}${encodeSubString}${SALT2}`);
  return encodePayload;
}

export function getNomineeRelation(relationValue?: string | null): boolean {
  return ['MOTHER', 'FATHER', 'DAUGHTER', 'SON', 'SPOUSE', 'BROTHER', 'SISTER', ''].includes(
    relationValue || ''
  );
}
export function applicationDownloadStatusCheck(status: string): boolean {
  return APPLICATION_LISTING_STATUS[status] !== APPLICATION_LISTING_STATUS.completed;
}

export function isMigrationAndTinDocument(documentType: string): boolean {
  return ['migration_document', 'tinProof', 'guardianTinProof', 'nomineeTinProof'].includes(
    documentType
  );
}
export function valueIsNone(value: any): boolean {
  return value === 'none';
}

export const isDateSame = (date1: Date, date2: Date): boolean => {
  const { moment } = new AdapterMoment({ instance: momentTimezone });
  moment.tz.setDefault(timeZoneFromServer);
  momentTimezone.tz.setDefault(timeZoneFromServer);
  return (
    moment(date1).get('D') === moment(date2).get('D') &&
    moment(date1).get('M') === moment(date2).get('M') &&
    moment(date1).get('y') === moment(date2).get('y')
  );
};

export const futureAge = (dateOfBirth = ''): boolean => {
  return new Date(dateOfBirth) > new Date();
};

export const DocumentmaxFileSize = (documentType: string) =>
  ['signedForm'].includes(documentType)
    ? '20MB'
    : isMigrationAndTinDocument(documentType)
    ? '3MB'
    : '2MB';

export const DocumentLabelMaxFileSize = (documentType: string) =>
  `Max file size is ${DocumentmaxFileSize(documentType)}`;

export const DocumentacceptedFileTypes = (documentType: string) =>
  ['investorSignature', 'investorPhotograph'].includes(documentType)
    ? INVESTOR_IMAGE_UPLOAD_FORMATS
    : ['signedForm'].includes(documentType)
    ? FINAL_DOC_UPLOAD_FORMATS
    : IMAGE_UPLOAD_FORMATS;

export const DocumentLabelIdle = (documentType: string) =>
  `<span class="filepond--label-action">Choose File <div>Max Size: ${DocumentmaxFileSize(
    documentType
  )}</div>Supports: ${DocumentacceptedFileTypes(documentType)
    .map((item) => item.split('/')[1])
    .join(', ')}</span>`;

export function AddMultiField(fields: (string | undefined)[]): string {
  return fields.filter((ele) => ele).join(' ');
}

export function USTaxableUSNonTaxableInvestorAccess(investorType: string): boolean {
  return ['USTaxable', 'USNonTaxable'].includes(investorType);
}

export function accreditedInvestorTypeCapture(
  isAccreditedInvestor: string,
  investorType: string
): boolean {
  return (
    YesNoMaster[isAccreditedInvestor] === YesNoMaster.yes &&
    USTaxableUSNonTaxableInvestorAccess(investorType)
  );
}

export function AlternateEmailNotificationYesNo(value?: boolean | null): string {
  return value === false ? 'No' : value === true ? 'Yes' : '';
}

export const getArrayLength = (arrayList: number) => {
  return Array.from(
    {
      length: arrayList,
    },
    (value, index) => index + 1
  );
};

export const ApprovedByAllApplicant = (
  noOfApplicants: number,
  applicationStatus: string
): boolean => {
  return (
    APPLICATION_STATUS[`approved_by_applicant${noOfApplicants}`] ===
    APPLICATION_STATUS[applicationStatus]
  );
};

export const FormVerification = (pathName: string): boolean =>
  pathName === '/applications-list/form';

export const DocumentVerification = (pathName: string): boolean =>
  pathName === '/applications-list/document';

export const ApplicationStatus = (status: string, signed_by_applicants: boolean) => {
  return {
    ...APPLICATION_LISTING_STATUS,
    ...(signed_by_applicants
      ? {
          approved_by_applicant1: 'Signed By Investor(s)',
          approved_by_applicant2: 'Signed By Investor(s)',
          approved_by_applicant3: 'Signed By Investor(s)',
        }
      : {}),
    sent_to_applicant1: 'Sent to Investor(s)',
  }[status];
};

export const IndividualApplicationStatusBasedOnRoleAndSign = (
  role: any,
  status: string,
  signed_by_applicants: boolean,
  pathBased: boolean
) => {
  return {
    ...IndividualApplicationStatusBasedOnRole[role],
    ...(signed_by_applicants
      ? {
          approved_by_applicant1: 'Signed By Investor(s)',
          approved_by_applicant2: 'Signed By Investor(s)',
          approved_by_applicant3: 'Signed By Investor(s)',
        }
      : {}),
    ...(pathBased && signed_by_applicants
      ? {
          sent_to_amc_approver: ENABLE_RTA_APPROVER ? 'Sent to AIF approver' : 'Sent to approver',
          approved_by_applicant1: 'Pending',
          approved_by_applicant2: 'Pending',
          approved_by_applicant3: 'Pending',
        }
      : {}),
    sent_to_applicant1: 'Sent to Investor(s)',
  }[status];
};

export const statusClassName = (role: any, application: ApplicationProps) => {
  return application.hasPOA || checkIfApplicationIsNonIndividual(application)
    ? [USER_ROLES.AMCAPPROVER, USER_ROLES.RTAAPPROVER, USER_ROLES.POAAPPROVER].includes(role)
      ? ApplicationStatusBasedOnRole[role][application.status]
      : ApplicationStatus(application.status, application.signed_by_applicants)
    : !checkIfApplicationIsNonIndividual(application) &&
      [USER_ROLES.AMCAPPROVER, USER_ROLES.RTAAPPROVER].includes(role)
    ? IndividualApplicationStatusBasedOnRoleAndSign(
        role,
        application.status,
        application.signed_by_applicants,
        false
      )
    : ApplicationStatus(application.status, application.signed_by_applicants);
};

export function isABenefitPlanInvestor(isBenefitPlanInvestor: string): boolean {
  return YesNoMaster[isBenefitPlanInvestor || ''] === YesNoMaster.yes;
}

export const getCountryCodeBasedOnName = (name: string, mdmsCountriesList: mdmsCountriesList[]) => {
  return mdmsCountriesList.find((country) => country.name === name)?.code;
};

export const checkBankCountry = (bank: updatedBank[], mdmsCountriesList: mdmsCountriesList[]) => {
  return bank.some((_bank) =>
    ['MM', 'IR', 'KP'].includes(
      getCountryCodeBasedOnName(_bank.bankCountry, mdmsCountriesList) || ''
    )
  );
};

export const fieldNotApplicable = (value: string | number | null | undefined) => {
  return value?.toString()?.toUpperCase() === 'NA';
};

export const checkValidationBasedOnDate = (
  date: string | number | Date,
  validationStartDate: string
): boolean => {
  if (!date) return false;
  if (!validationStartDate) return true;
  const dateForCompare = date ? new Date(date) : new Date();
  const dateForApplyValidations = new Date(validationStartDate || '');
  return dateForCompare.getTime() >= dateForApplyValidations.getTime();
};

export const doYouHavePanCopy = (panCardAvailable: string): boolean => {
  return YesNoMaster[panCardAvailable] === YesNoMaster.yes;
};

export const investorSubCategoryNRIorOCI = (investorSubCategory: string): boolean => {
  return ['nri', 'oci'].includes(investorSubCategory?.toLowerCase());
};

export const havePanCopyDependentDocs = (documentType: string): boolean => {
  return ['self_certified_pan_copy', 'indian_passport', 'oci_card'].includes(documentType);
};

export const accreditedInvestorPresent = (investorType: string, createdAt: string): boolean =>
  checkValidationBasedOnDate(createdAt, AccreditedInvestorMandatoryDate)
    ? ['USTaxable', 'USNonTaxable', 'OtherGlobalInvestor'].includes(investorType)
    : USTaxableUSNonTaxableInvestorAccess(investorType);

export function checkIfApplicationIsIndividualPOA(application: ApplicationProps): boolean {
  if (application) {
    const { applicationType, hasPOA } = application;
    return applicationType === APPLICATION_TYPE.INDIVIDUAL && hasPOA;
  } else return false;
}

export const checkSupportLogin = (createdBy: string | number, id: string | number): boolean => {
  return Number(createdBy) === Number(id);
};

export const checkSubDisDisable = (
  role: any,
  createdBy: string | number,
  id: string | number
): boolean => {
  return (
    [
      USER_ROLES.DISTRIBUTOR,
      USER_ROLES.INVESTOR,
      USER_ROLES.POAAPPROVER,
      USER_ROLES.AMCAPPROVER,
      USER_ROLES.RM,
      USER_ROLES.AMC_ADMIN,
    ].includes(role) ||
    (USER_ROLES.SUBDISTRIBUTOR === role && !checkSupportLogin(Number(createdBy), Number(id)))
  );
};

export const checkIfDistributorIndividual = (type: string): boolean => {
  return type === 'individual';
};

export const isSupportSubDistributor = (subdistributorType: string): boolean => {
  return subdistributorType?.toLowerCase() === 'support';
};
export const handleDownload = async (fileUrl: string, fileName: string): Promise<void> => {
  try {
    const url = new URL(fileUrl, window.location.origin);

    const isSameOrigin = url.origin === window.location.origin;

    if (isSameOrigin) {
      // Same-origin: rename supported
      const response = await fetch(fileUrl);

      if (!response.ok) {
        throw new Error('Unable to download file');
      }

      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = fileName;

      document.body.appendChild(link);
      link.click();

      link.remove();
      URL.revokeObjectURL(blobUrl);
    } else {
      // Cross-origin (e.g. S3): no fetch => no CORS issue
      const link = document.createElement('a');
      link.href = fileUrl;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';

      document.body.appendChild(link);
      link.click();
      link.remove();
    }
  } catch (error) {
    console.error('Download failed:', error);
    throw error;
  }
};
